import { type Descendant, type Editor, Element, Transforms } from 'slate';
import { isMediaElement } from '../../types/guards';

// Slate's default drag/copy+paste behavior will include every ancestor in
// the fragment. This means that dragging/copying a media element that's in
// a list or table will also take the list or table with it.

// Here we check if we have a media element with only ancestors that have
// no siblings. If so, we can remove them and just paste a media element
// wrapped in a single paragraph.
export const removeMediaAncestors = (
  editor: Editor,
  fragment: Descendant[]
): boolean => {
  if (fragment.length !== 1) return false;

  let node: Descendant = fragment[0];
  let newFragment: Descendant[] | undefined;

  while (node) {
    if (isMediaElement(node)) {
      newFragment = [
        {
          type: 'paragraph',
          children: [node],
        },
      ];
      break;
    }

    if (!Element.isElement(node) || node.children.length !== 1) return false;

    node = node.children[0];
  }

  if (newFragment) {
    Transforms.insertFragment(editor, newFragment);
    return true;
  }

  return false;
};
